// libraries
import React from 'react';
import Select, { components } from 'react-select';

// assets
import { ReactComponent as SearchIcon } from '../../../assets/icons/search.svg';

interface IProps {
  allTags: { [key: number]: { id: number; title: string } } | {};
  selectedTags: number[];
  selectTag: (id: number) => void;
}

export const Search = ({ allTags, selectedTags, selectTag }: IProps) => {
  const [selectValue, setSelectValue] = React.useState<{
    value: number;
    label: string;
  } | null>(null);

  const getOptions = () => {
    let options: { value: number; label: string }[] = [];
    Object.values(allTags).map(item => {
      if (!selectedTags.includes(item.id))
        options.push({ value: item.id, label: item.title });
    });

    return options;
  };

  const DropdownIndicator = (props: any) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <SearchIcon />
        </components.DropdownIndicator>
      )
    );
  };

  return (
    <Select
      placeholder={'Введіть назву тегу...'}
      classNamePrefix="tagsearch"
      className={'tagsearch'}
      options={getOptions()}
      value={selectValue}
      isClearable={true}
      noOptionsMessage={() => 'Такого тегу немає! Спробуйте ще.'}
      onChange={value => {
        if (value) selectTag(value.value);
      }}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator,
      }}
    />
  );
};

export default Search;
